import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import CloudinaryImage from '../../../../cloudinary-media/image'

const Banner = ({desktopImage, mobileImage, imageAlt}) => {
    const mobileSrc = mobileImage || desktopImage

    return (
        <>
            <Box display={{base: 'none', md: 'block'}} height="100%">
                <CloudinaryImage
                    src={desktopImage}
                    aspectRatio="96:78"
                    imgSizes={{base: '50vw'}}
                    sizes={[410, 600, 720, 960]}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: '96/78',
                        width: 'auto',
                        height: '100%',
                        objectFit: 'cover',
                        htmlWidth: 96,
                        htmlHeight: 78
                    }}
                />
            </Box>
            <Box display={{base: 'block', md: 'none'}}>
                <CloudinaryImage
                    src={mobileSrc}
                    aspectRatio="453:317"
                    imgSizes={{base: '100vw'}}
                    sizes={[375, 390, 414, 768]}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: '453/317',
                        width: '100%',
                        height: 'auto',
                        htmlWidth: 453,
                        htmlHeight: 317
                    }}
                />
            </Box>
        </>
    )
}

Banner.propTypes = {
    desktopImage: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    imageAlt: PropTypes.string
}

export default Banner
